import { create } from 'zustand';

interface RewardNftsMarketplaceFiltersStore {
  readonly searchTerm: string;
  readonly sortOrder: string;
  readonly isEligibleToParticipate: boolean;
  readonly isEligibleToParticipateInPremium: boolean;
  readonly auctionType: string;
  readonly auctionStatus: string;
  readonly collection: string;
  readonly floorPrices: Record<string, number>;

  actions: {
    setSearchTerm: (val: string) => void;
    setSortOrder: (val: string) => void;
    setIsEligibleToParticipate: (val: boolean) => void;
    setIsEligibleToParticipateInPremium: (val: boolean) => void;
    setAuctionType: (val: string) => void;
    setAuctionStatus: (val: string) => void;
    setCollection: (val: string) => void;
    updateFloorPrices: (address: string, price: number) => void;
  };
}

export const useRewardNftsMarketplaceFiltersState =
  create<RewardNftsMarketplaceFiltersStore>((setState, getState) => ({
    searchTerm: '',
    sortOrder: 'desc',
    isEligibleToParticipate: false,
    isEligibleToParticipateInPremium: false,
    auctionType: '',
    auctionStatus: '',
    collection: '',
    floorPrices: {},
    actions: {
      setSearchTerm: (val: string) => setState({ searchTerm: val }),
      setSortOrder: (val: string) => setState({ sortOrder: val }),
      setAuctionType: (val: string) => setState({ auctionType: val }),
      setAuctionStatus: (val: string) => setState({ auctionStatus: val }),
      setCollection: (val: string) => setState({ collection: val }),
      updateFloorPrices: (address: string, price: number) =>
        setState({
          floorPrices: { ...getState().floorPrices, [address]: price }
        }),
      setIsEligibleToParticipate: (val: boolean) =>
        setState({ isEligibleToParticipate: val }),
      setIsEligibleToParticipateInPremium: (val: boolean) =>
        setState({ isEligibleToParticipateInPremium: val })
    }
  }));
